import React, { useCallback, useEffect, useState } from 'react'
import {Segment, Form, Button, Dimmer,Loader } from 'semantic-ui-react';
import { Formik } from 'formik';
import ReactDatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import APIService from '../../Services/API/APIService';
import * as Yup from "yup";
import { toast } from "react-toastify";

const AddExtraDays = (prop) => {

    const [loading, setLoading] = useState(false)
    const [bookedDay, setBookingDay] = useState(null)
    const [disabled,setDisbaled] = useState(false)

    const fetchData = useCallback( async (isSubscribed) => {
        try {

            setLoading(true);
            let response = await APIService.getData('/guest-house/getLatestDay', {
                room: prop.booking.GuestHousePackage.roomCode,
                checkout : prop.booking.checkout
            })
            if(isSubscribed){
                setBookingDay(response?.checkin)
                const  checkout = dayjs(prop?.booking?.checkout).add('1','day')
                dayjs(checkout).isSame(response?.checkin,'day')  ? setDisbaled(true) : setDisbaled(false)
            }

          
            setLoading(false)
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    },[prop.booking.GuestHousePackage.roomCode,prop.booking.checkout])

    
    useEffect(() => {
        let isSubscribed = true
        fetchData(isSubscribed)

        return () => (isSubscribed = false)
    }, [fetchData])

    const addDays = async (values) => {
        try {
            setLoading(true)
            let response = await APIService.postData('/guest-house/addExtraDays', {
                date: values.date,
                reference: prop.booking?.reference,
                GuestHouseBookingId: prop.booking?.id,
                GuestHousePackageId: prop.booking?.GuestHousePackageId,
                productType: 7,
                PurchaseId: prop.booking?.PurchaseId


            })
            setLoading(false)
            prop.toggleExtraDaysModal(false)
            if (response) {
                toast.success('successful')
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    const schema = Yup.object().shape({
        date: Yup.date().required("Required"),

    });



    return (
        <div>
            {loading && (
                <Dimmer active inverted>
                    <Loader />
                </Dimmer>
            )}

            <Segment textAlign="left" loading={loading}>

                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        date: "",

                    }}
                    validationSchema={schema}
                    onSubmit={addDays}
                >
                    {(props) => {
                        const {
                            values,
                            handleSubmit,
                        } = props;
                        return (
                            <Form onSubmit={handleSubmit}>

                                <Form.Input
                                    control={ReactDatePicker}
                                    placeholderText="Select a date"
                                    disabled ={disabled}
                                    minDate={dayjs(prop?.booking?.checkout).add(1, 'day').toDate()}
                                    maxDate={bookedDay ? dayjs(bookedDay).toDate() : dayjs(prop?.booking?.checkout).add(3, 'months').toDate()}

                                    selected={
                                        values.date
                                            ? dayjs(values.date).toDate()
                                            : ""
                                    }
                                    onChange={(value) => {
                                        props.setFieldValue("date", value);
                                    }}
                                />

                                <Button style={{ backgroundColor: '#26f09e', color: '#000000' }} content="Add" />
                            </Form>
                        );
                    }}
                </Formik>

            </Segment>

        </div>
    )
}

export default AddExtraDays